import { MinzeElement } from 'minze'

export class LvcSearch extends MinzeElement {
  html = () => `
    <lvc-search-menu data-element-location="search-page"></lvc-search-menu>
    <lvc-search-results></lvc-search-results>
  `
}
